<div class="table-container">
  <table mat-table [dataSource]="templates" matSort>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.dialogs.description" |translate}}</th>
      <td mat-cell *matCellDef="let template">{{template.description}}</td>
    </ng-container>

    <ng-container matColumnDef="category.description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.templates.category" |translate}}</th>
      <td mat-cell *matCellDef="let template">{{template.category.description}}</td>
    </ng-container>

    <ng-container matColumnDef="subject">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.templates.subject" |translate}}</th>
      <td mat-cell *matCellDef="let template">{{template.subject}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let template">
        <mat-icon (click)="editTemplate(template)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
        <mat-icon *ngIf="template.status === 'ACTIVE'" color="primary"
                  matTooltip="Disable" matTooltipPosition="above"
                  (click)="updateTemplate(template, false)">check_circle
        </mat-icon>
        <mat-icon *ngIf="template.status === 'INACTIVE'"
                  color="primary" matTooltip="Enable" matTooltipPosition="above"
                  (click)="updateTemplate(template, false)">radio_button_unchecked
        </mat-icon>
        <mat-icon *ngIf="template.status === 'INACTIVE'"
                  color="primary" matTooltip="Delete" matTooltipPosition="above"
                  (click)="updateTemplate(template, true)">delete
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
